/*
 *
 * File: languages_reducer.js
 *
 * Purpose: Language reducer for switch language (de or en).
 *
 * Author:  Thomas Burgard (Software development)
 * Created: 03.05.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import { CHANGE_LANGUAGE } from "../types";

/**
 * User reducer function.
 * 
 * @param {*} state Redux state as app wide store (initial state is de for german language)
 * @param {*} action which action is then processing
 * @returns state
 */
export default function languageReducer(state = {language: "de"}, action) {
  switch (action.type) {
    // Get user data from Server
    case CHANGE_LANGUAGE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
